import http from './http'

export function getFeatureSettings() {
  return http.get('/public/feature-settings', { skipAuthRedirect: true })
}
